import {Component, Input, OnInit} from '@angular/core';
import {FormControl, Validators} from "@angular/forms";
import {CustomerService} from "../../core/services/customer.service";
import {Company} from "../model/company.model";
import {SnackBarService} from "../../core/services/snack-bar.service";
import {tap} from "rxjs/operators";

@Component({
  selector: 'app-lessor-group-info',
  templateUrl: './lessor-group-info.component.html',
  styleUrls: ['./lessor-group-info.component.css']
})
export class LessorGroupInfoComponent implements OnInit {
  groupControl: FormControl;

  @Input() company: Company;

  get groupId() {
    return this.company.group?.id;
  }

  constructor(private customerService: CustomerService,
              private snackBarService: SnackBarService) { }

  ngOnInit(): void {
    this.groupControl = new FormControl('', Validators.required);
    if (this.company.group) {
      this.groupControl.setValue(this.company.group.id);
    }
  }

  assign() {
    return this.customerService.assignGroup(this.company.id, this.groupControl.value)      .pipe(
      tap(_ => this.snackBarService.displayText(`Przypisano do grupy`))
    )
    .subscribe(_ => {});
  }

  unassign() {
    return this.customerService.unassignGroup(this.company.id)
      .pipe(
        tap(_ => this.snackBarService.displayText(`Wypisano z grupy`))
      )
      .subscribe(_ => {
        this.groupControl.reset();
      });
  }
}
